import { Component, OnInit } from '@angular/core';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';


@Component({
  selector: 'app-clients',
  templateUrl: './clients.component.html',
  styleUrls: ['./clients.component.scss'],
})
export class ClientsComponent implements OnInit {

  config: SwiperConfigInterface = {
    slidesPerView: 1,
    spaceBetween: 0,
    autoplay: true,
    loop: true,
    initialSlide: 0,
    effect: 'fade',
    // fadeEffect: {
    //   crossFade: true
    // },
  };

  clients(n: number): any[] {
    return Array(n);
  }

  constructor() {}

  ngOnInit() {}
}
